import type { TourDefinition } from '@renderer/hooks/useTour';

export const tourUsuarios: TourDefinition = {
  id: 'usuarios',
  title: 'Cómo gestionar usuarios',
  steps: [
    {
      element: '[data-tour="usr-nuevo"]',
      popover: {
        title: '1. Agregar usuario',
        description:
          'Toca "Nuevo usuario" para crear un mesero, cajero o dueño. Cada uno tiene acceso solo a lo que su rol permite.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="usr-tabla"]',
      popover: {
        title: '2. Lista de usuarios y roles',
        description:
          'Aquí ves todos los usuarios registrados, su rol (dueño, mesero, cajero…) y si están activos. El color del badge indica el rol.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="usr-acciones"]',
      popover: {
        title: '3. Editar y activar/desactivar',
        description:
          'El ícono de lápiz edita el usuario. El ícono de persona activa o desactiva su acceso sin borrar su historial.',
        side: 'left',
      },
    },
  ],
};
